import { defineStore } from "pinia";
import { getDownloadURL, ref as storeRef } from 'firebase/storage'
import { storage } from '../util/firebase';

export const useDocuments = defineStore("documents", () => {
    const cache = new Map<string, string>();

    async function getUrl(storageRef: string) {
        if(cache.has(storageRef)) return cache.get(storageRef);
        else {
            const tmp = storeRef(storage, storageRef);
            const url = await getDownloadURL(tmp);
            cache.set(storageRef, url);
            return url;
        }
    }

    return { getUrl };
})